import { render, staticRenderFns } from "./AnnotationTypeInsurer.vue?vue&type=template&id=9801617c&scoped=true"
import script from "./AnnotationTypeInsurer.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeInsurer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTypeInsurer.vue?vue&type=style&index=0&id=9801617c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9801617c",
  null
  
)

export default component.exports